import React from "react";
// import About from './component/About/About';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ChakraProvider } from "@chakra-ui/react";
import Home from "./component/Homepage/Home";
// import Af from './component/AfNav/Af';
// import Navbar from './component/Nav/Navbar';
// import Work from './component/work/Work';
// import Support from './component/support/Support';
// import Points from './component/points/Points';
// import Comit from './component/commitment/Comit';
// import Faq from './component/faq/Faq';
// import Slide from './component/slide/Slide';
// import Down from './component/download/Down';
// import Futer from './component/foot/Futer';
import "./css/index.css";
import Faqone from "./component/FaqPage/Faqone"
import Faqtwo from "./component/FaqPage/Faqtwo"
import Faqthree from "./component/FaqPage/Faqthree"
import Privacy from "./component/privacy/Privacy"
import Terms from "./component/Terms&service/Terms"

function App() {
  return (
    <BrowserRouter>
      <ChakraProvider>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/faq-one" element={<Faqone />} />
          <Route path="/faq-two" element={<Faqtwo />} />
          <Route path="/faq-three" element={<Faqthree />} />
          <Route path="/termas-a" element={<Terms />} />
          <Route path="/privacy-p" element={<Privacy />} />
         
        </Routes>
      </ChakraProvider>
    </BrowserRouter>
  );
}

export default App;
